import React from "react"
import PropTypes from "prop-types"
import RaisedButton from "material-ui/RaisedButton"
import TextField from "material-ui/TextField"
import Checkbox from "material-ui/Checkbox"
import FlatButton from "material-ui/FlatButton"
import RadioButton from "material-ui/RadioButton"
import RadioButtonGroup from "material-ui/RadioButton/RadioButtonGroup"

import DateField from "../../../../components/misc/DateField"
import VerifyField from "../../../../components/misc/VerifyField"

const i9Actions = require("../../../../actions/I9Actions")
const moment = require("moment")

const styles = {
    radioButtonContainer: {
        marginTop: 10
    }
}

const propTypes = {
    i9: PropTypes.object,
    onValueChange: PropTypes.func
}

export default class I9CitizenshipInfo extends React.Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            selection: -1,
            showAlienRegistrationUSCISNumber: false,
            alienNumberType: 0,
            showAlienRegistrationUSCISNumber2: true,
            showNonCitizenNational: false,
            workToDateValid: false
        }
        this.onChange = this.onChange.bind(this)
        this.onAlienRegistrationUSCISNumberChange = this.onAlienRegistrationUSCISNumberChange.bind(this)
        this.onWorkToDateCheckChange = this.onWorkToDateCheckChange.bind(this)
        this.handleWorkDateToChange = this.handleWorkDateToChange.bind(this)
        this.onAlienNumberTypeChange = this.onAlienNumberTypeChange.bind(this)
        this.onI94AdmissionNumberChange = this.onI94AdmissionNumberChange.bind(this)
        this.onForeignPassportNumberChange = this.onForeignPassportNumberChange.bind(this)
        this.onForeignPassportCountryChange = this.onForeignPassportCountryChange.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.i9) {
            const _this = this

            this.setState(
                {
                    i9: nextProps.i9
                },
                () => {
                    _this.setState(
                        {
                            selection: this.getCitizenshipSelection(),
                            alienNumberType: this.getAlienNumberType(nextProps.i9)
                        },
                        () => {
                            _this.setupAlienTypeFields(this.getAlienNumberType(nextProps.i9))
                        }
                    )
                }
            )
        }
    }

    getCitizenshipSelection() {
        if (this.state.i9.Employee_IsUSACitizen) return 0
        if (this.state.i9.Employee_IsNonCitizenNationalOfUSA) return 1
        if (this.state.i9.Employee_IsLawfulPermanentResident) return 2
        if (this.state.i9.Employee_IsAuthorizedAlien) return 3

        return -1
    }

    getAlienNumberType(i9) {
        if (i9) {
            if (i9.Employee_I94Selected) {
                return 1
            }
        }

        return 0
    }

    onChange(event, value) {
        const _this = this
        this.setState(
            {
                selection: value
            },
            () => {
                _this.setupFields()
                this.state.i9.Employee_IsUSACitizen = this.state.selection === 0
                this.state.i9.Employee_IsNonCitizenNationalOfUSA = this.state.selection === 1
                this.state.i9.Employee_IsLawfulPermanentResident = this.state.selection === 2
                this.state.i9.Employee_IsAuthorizedAlien = this.state.selection === 3
                this.updateI9()

                i9Actions.patchSection1Data(this.state.i9.I9Id, {
                    Employee_IsUSACitizen: this.state.i9.Employee_IsUSACitizen,
                    Employee_IsNonCitizenNationalOfUSA: this.state.i9.Employee_IsNonCitizenNationalOfUSA,
                    Employee_IsLawfulPermanentResident: this.state.i9.Employee_IsLawfulPermanentResident,
                    Employee_IsAuthorizedAlien: this.state.i9.Employee_IsAuthorizedAlien
                })
            }
        )
    }

    onAlienNumberTypeChange(event, value) {
        const _this = this
        const i94Selected = value === 1

        this.state.i9.Employee_I94Selected = i94Selected
        this.updateI9()
        i9Actions.patchSection1Data(this.state.i9.I9Id, {
            Employee_I94Selected: i94Selected
        })
        this.setupAlienTypeFields(value)
    }

    setupAlienTypeFields(value) {
        const i94Selected = value === 1
        const _this = this
        this.setState(
            {
                alienNumberType: value,
                showAlienRegistrationUSCISNumber2: !i94Selected,
                showAlienRegistrationFormI94: i94Selected
            },
            () => {
                _this.setupFields()
            }
        )
    }

    setupFields() {
        switch (this.state.selection) {
            case 1: {
                this.setState({
                    showAlienRegistrationUSCISNumber: false,
                    showExpirationDate: false,
                    showNonCitizenNational: true
                })
                break
            }
            case 2: {
                this.setState({
                    showAlienRegistrationUSCISNumber: true,
                    showExpirationDate: false,
                    showNonCitizenNational: false
                })
                break
            }
            case 3: {
                this.setState({
                    showExpirationDate: true,
                    showAlienRegistrationUSCISNumber: false,
                    showNonCitizenNational: false
                })
                break
            }
            default: {
                this.setState({
                    showAlienRegistrationUSCISNumber: false,
                    showExpirationDate: false,
                    showNonCitizenNational: false
                })
                break
            }
        }
    }

    validate(i9) {
        if (!i9) {
            return false
        }

        if (!i9.Employee_IsUSACitizen && !i9.Employee_IsNonCitizenNationalOfUSA && !i9.Employee_IsLawfulPermanentResident && !i9.Employee_IsAuthorizedAlien) {
            return false
        } else {
            if (i9.Employee_IsLawfulPermanentResident) {
                if (!i9.Employee_AlienRegistrationUSCISNumber || i9.Employee_AlienRegistrationUSCISNumber.length === 0) {
                    return false
                }
            }

            if (i9.Employee_IsAuthorizedAlien) {
                if (i9.Employee_AuthorizedAlienWorkToDateContainsValue) {
                    if (i9.Employee_AuthorizedAlienWorkToDate) {
                        const workToDate = moment(i9.Employee_AuthorizedAlienWorkToDate)
                        if (workToDate.year() === 1) {
                            return false
                        }

                        if (!i9.Employee_I94Selected && (!i9.Employee_AlienRegistrationUSCISNumber || i9.Employee_AlienRegistrationUSCISNumber.length === 0)) {
                            return false
                        }
                    } else {
                        return false
                    }
                }

                if (i9.Employee_I94Selected) {
                    if (!i9.Employee_I94AdmissionNumber || i9.Employee_I94AdmissionNumber.length === 0) {
                        return false
                    }
                    if (!i9.Employee_ForeignPassportNumber || i9.Employee_ForeignPassportNumber.length === 0) {
                        return false
                    }
                    if (!i9.Employee_ForeignPassportCountry || i9.Employee_ForeignPassportCountry.length === 0) {
                        return false
                    }
                }
            }

            return true
        }
    }

    updateI9() {
        if (this.props.onValueChange) {
            this.props.onValueChange(this.state.i9)
        }
    }

    onAlienRegistrationUSCISNumberChange(value) {
        this.state.i9.Employee_AlienRegistrationUSCISNumber = value
        this.updateI9()
        i9Actions.patchSection1Data(this.state.i9.I9Id, {
            Employee_AlienRegistrationUSCISNumber: value
        })
    }

    handleWorkDateToChange(value, valid) {
        this.state.i9.Employee_AuthorizedAlienWorkToDate = value
        this.updateI9()

        if (valid) {
            i9Actions.patchSection1Data(this.state.i9.I9Id, {
                Employee_AuthorizedAlienWorkToDate: value
            })
        }

        this.setState({
            workToDateValid: valid
        })
    }

    onWorkToDateCheckChange(obj, checked) {
        this.state.i9.Employee_AuthorizedAlienWorkToDateContainsValue = checked
        this.updateI9()
        i9Actions.patchSection1Data(this.state.i9.I9Id, {
            Employee_AuthorizedAlienWorkToDateContainsValue: checked
        })
    }

    onForeignPassportNumberChange(value) {
        this.state.i9.Employee_ForeignPassportNumber = value
        this.updateI9()
        i9Actions.patchSection1Data(this.state.i9.I9Id, {
            Employee_ForeignPassportNumber: value
        })
    }

    onI94AdmissionNumberChange(value) {
        this.state.i9.Employee_I94AdmissionNumber = value
        this.updateI9()
        i9Actions.patchSection1Data(this.state.i9.I9Id, {
            Employee_I94AdmissionNumber: value
        })
    }

    onForeignPassportCountryChange(value) {
        this.state.i9.Employee_ForeignPassportCountry = value
        this.updateI9()
        i9Actions.patchSection1Data(this.state.i9.I9Id, {
            Employee_ForeignPassportCountry: value
        })
    }

    render() {
        return (
            <div className="citizenship-info I9CitizenshipInfo">
                <b>Citizenship Information</b>
                <div style={{ textAlign: "left" }}>
                    I am aware that federal law provides for imprisonment and/or fines for false statements or use of false documents in connection with the completion of this form.
                    <br />
                    <br />
                    <b>I attest, under penalty of perjury, that I am (select one of the following): </b>
                </div>

                <div style={{ textAlign: "left" }}>
                    <RadioButtonGroup name="citizenshipStatus" defaultSelected="0" onChange={this.onChange} valueSelected={this.state.selection}>
                        <RadioButton label="A citizen of the United States" style={styles.radioButtonContainer} value={0} />
                        <RadioButton label="A noncitizen national of the United States" style={styles.radioButtonContainer} value={1} />
                        <RadioButton label="A lawful permanent resident" style={styles.radioButtonContainer} value={2} />
                        <RadioButton label="An alien authorized to work" style={styles.radioButtonContainer} value={3} />
                    </RadioButtonGroup>

                    {this.state.showNonCitizenNational && (
                        <div style={{ paddingLeft: 40, marginTop: 10 }}>
                            Noncitizen nationals of the United States are persons born in American Samoa, certain former citizens of the former Trust Territory of the Pacific Islands, and certain
                            children of noncitizen nationals born abroad.
                        </div>
                    )}

                    {this.state.showAlienRegistrationUSCISNumber && (
                        <div style={{ paddingLeft: 40 }}>
                            <VerifyField
                                autoFocus={true}
                                floatingLabelText="Alien Registration/USCIS Number"
                                value={this.state.i9 ? this.state.i9.Employee_AlienRegistrationUSCISNumber : ""}
                                onValueChange={this.onAlienRegistrationUSCISNumberChange}
                                style={{ width: "100%" }}
                            />
                            <div>
                                A lawful permanent resident is any person who is not a U.S. citizen and who resides in teh United States under legally recognized and lawfully recorded permanent
                                residence as an immigrant. The term "lawful permanent resident" includes conditional residents.
                            </div>
                        </div>
                    )}

                    {this.state.showExpirationDate && (
                        <div
                            style={{
                                paddingLeft: 40,
                                paddingRight: 10,
                                marginTop: 20,
                                marginBottom: 10
                            }}
                        >
                            <Checkbox
                                label="Authorized to Work until below expiration date"
                                checked={this.state.i9 ? this.state.i9.Employee_AuthorizedAlienWorkToDateContainsValue : true}
                                onCheck={this.onWorkToDateCheckChange}
                            />

                            {(this.state.i9 ? (this.state.i9.Employee_AuthorizedAlienWorkToDateContainsValue ? true : false) : true) && (
                                <div>
                                    <DateField style={{ marginLeft: 40 }} value={this.state.i9 ? this.state.i9.Employee_AuthorizedAlienWorkToDate : ""} handleChange={this.handleWorkDateToChange} />
                                </div>
                            )}

                            <div style={{ marginTop: 10 }}>Alien Authorization Number Type</div>

                            <RadioButtonGroup name="typeOfAlienNumber" defaultSelected="0" onChange={this.onAlienNumberTypeChange} valueSelected={this.state.alienNumberType}>
                                <RadioButton label="Alien Registration/USCIS" style={styles.radioButtonContainer} value={0} />
                                <RadioButton label="Form I-94 Admission Number" style={styles.radioButtonContainer} value={1} />
                            </RadioButtonGroup>

                            {this.state.showAlienRegistrationUSCISNumber2 && (
                                <VerifyField
                                    floatingLabelText="Alien Registration/USCIS Number"
                                    value={this.state.i9 ? this.state.i9.Employee_AlienRegistrationUSCISNumber : ""}
                                    onValueChange={this.onAlienRegistrationUSCISNumberChange}
                                    style={{ width: "100%" }}
                                />
                            )}

                            {this.state.showAlienRegistrationFormI94 && (
                                <div>
                                    <VerifyField
                                        floatingLabelText="Form I-94 Admission Number"
                                        value={this.state.i9 ? this.state.i9.Employee_I94AdmissionNumber : ""}
                                        onValueChange={this.onI94AdmissionNumberChange}
                                    />

                                    <div style={{ marginTop: 20 }}>If you obtained your admission number from CBP in connection with your arrival in the United States, include the following :</div>

                                    <div style={{ paddingLeft: 40 }}>
                                        <VerifyField
                                            floatingLabelText="Foreign Passport Number (or NA)"
                                            value={this.state.i9 ? this.state.i9.Employee_ForeignPassportNumber : ""}
                                            onValueChange={this.onForeignPassportNumberChange}
                                            style={{ width: "100%" }}
                                        />
                                        <VerifyField
                                            floatingLabelText="Country of Issuance (or NA)"
                                            value={this.state.i9 ? this.state.i9.Employee_ForeignPassportCountry : ""}
                                            onValueChange={this.onForeignPassportCountryChange}
                                            style={{
                                                width: "100%",
                                                marginTop: -10,
                                                marginBottom: 10
                                            }}
                                        />
                                        <span>
                                            If you obtained your admission number from USCIS <i>within the United States</i>, or you entered the United States without a foreign passport, you must
                                            write "NA" in the Foreign Passport Number and Country of Issuance fields.
                                        </span>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

I9CitizenshipInfo.propTypes = propTypes
